/**
 * SpawnState: captures a controller pose at spawn so it can be restored later
 * (e.g. R key reset). Ported from supersplat-viewer/src/cameras/spawn-state.ts.
 */

import { Vec3 } from 'playcanvas';

class SpawnState {
    private _position = new Vec3();
    private _angles = new Vec3();
    private _has = false;

    get has(): boolean { return this._has; }

    store(position: Vec3, angles: Vec3) {
        this._position.copy(position);
        this._angles.copy(angles);
        this._has = true;
    }

    clear() {
        this._has = false;
    }

    restore(position: Vec3, angles: Vec3) {
        position.copy(this._position);
        angles.copy(this._angles);
    }
}

export { SpawnState };
